import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2031 12.2344L7.125 0L0 12.2344L7.125 16.5938L14.2031 12.2344ZM7.125 18L0 13.6406L7.125 24L14.25 13.6406L7.125 18Z"
      fill="#ECEDEE"
    />
  </svg>
)
